import { Header as UIHeader, HeaderProps as UIHeaderProps } from '@instabox/consumer-web-ui'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC, forwardRef, ReactElement, ReactNode, Ref, useEffect, useState } from 'react'

import { TRACKING_URL, WWW_URL } from '../../constants'
import { PageProps } from '../../types'
import { getTranslation } from '../../utils'
import SwitchLanguageButton from '../SwitchLanguageButton'
import { ENV_CONFIG } from '../../constants/envConfig'

export interface HeaderProps extends UIHeaderProps {
  pageLinks: PageProps['pageLinks']
}

export const Header: FC<HeaderProps> = ({ pageLinks, ...props }) => {
  const [navBarItems, setNavBarItems] = useState<ReactElement[]>([])

  const { locale } = useRouter()

  useEffect(() => {
    if (Array.isArray(pageLinks)) {
      const origin = window.location.origin
      setNavBarItems(
        pageLinks.filter(Boolean).map(({ slug, meta_title, translations }) => {
          const metaTitle = getTranslation('meta_title', translations, meta_title)
          if (slug.startsWith('http')) {
            return (
              <a key={slug} href={getTranslation('slug', translations, slug)}>
                {metaTitle}
              </a>
            )
          }
          if (origin === TRACKING_URL || origin === '') {
            return (
              <a
                key={slug}
                href={`${WWW_URL}/${locale}/${getTranslation('slug', translations, slug)}`}>
                {metaTitle}
              </a>
            )
          }
          return (
            <Link key={slug} href={`/${slug}`} passHref legacyBehavior>
              <A>{metaTitle}</A>
            </Link>
          )
        }),
      )
    }
  }, [locale, pageLinks])

  return (
    <UIHeader
      logoUrl={`${ENV_CONFIG.WEB_URL ?? ''}/${locale}`}
      navBarItems={[...navBarItems, <SwitchLanguageButton key="language-switch" />]}
      {...props}
    />
  )
}

export default Header

interface AProps {
  href?: string
  children: ReactNode
}

const A = forwardRef(({ href, children }: AProps, ref: Ref<HTMLAnchorElement>) => {
  const withoutBasePath = href?.replace('/p/', '/')
  return (
    <a href={withoutBasePath} ref={ref}>
      {children}
    </a>
  )
})

A.displayName = 'A'
